import React from 'react';
import { Form, Localization } from 'connex-cds';
import { Styled } from './style';

const { Translate } = Localization;
const testId = 'activityGrid-damageWaiverAck';

export const DamageWaiverAck = () => {
  const { values } = Form.useFormContext();

  if (values.damageWaiverDeclined || !values.damageWaiverSignature?.image) {
    return null;
  }

  return (
    <Styled className="damage-waiver-mobile">
      <table>
        <tr className="header-row">
          <td className="header-cell" data-testid={`${testId}-activity-value`} colSpan="2">
            <Translate stringId="damageWaiverAcknowledged" />
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
        </tr>
      </table>
    </Styled>
  );
};
